export const EVENT_GROUP_SET_LAYERS = 'group:set-layers';
export const DRAWER_BLEEDING = 30;
export const DRAWER_BLEEDING_MODIFIER = 20;

export const EVENT_CHILD_APP_CLOSED = 'cads:child-app-closed';
